import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Button from '../components/common/Button';
import Input from '../components/common/Input';
import { useOnLoginMutation } from '../redux/service/modules/auth';
const Login = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const [onLogin, {isLoading: isLogin}] = useOnLoginMutation()
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const loginRes = await onLogin({data: {email}})
      if(loginRes?.data?.tokens) {
        await login({email, tokens: loginRes?.data?.tokens});
        navigate('/dashboard');
      }
      
    } catch (err) {
      console.error('Login failed:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex h-screen">
      <div className="hidden lg:block lg:w-2/5 bg-cover bg-center" style={{backgroundImage: "url('/images/login-background.png')"}}>
      </div>
      <div className="w-full lg:w-3/5 flex flex-col items-center justify-center px-5">
        <div className="mb-8">
          <img src="/images/ambit-logo.png" alt="AMBIT Logo" className="h-14" />
        </div>
        <div className="w-full p-8 bg-gray-50 rounded-md max-w-xl relative">
          <h1 className="text-2xl font-semibold mb-2">Log In with SSO</h1>
          <div className="inline-block">
            <p className="text-gray-500 text-sm mb-2">Enter your credentials to access your account</p>
            <div className="relative mt-4">
              <hr className="border-t-2 border-gray-300 w-full" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-3 h-3 bg-pink-300 rounded-full"></div>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="mt-2">
            <Input
              id="email"
              type="email"
              required
              placeholder="Email Id"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className="flex justify-end mt-6">
              <Button
                type="submit"
                disabled={isLoading}
                className="w-44"
              >
                {isLoading ? 'Processing...' : 'Proceed'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
